'use strict';

(function ($) {

    /**
     * @author Björn "Empu" Schädel
     */
    var aganSearch = {

        options: {
            tabletLandscapeViewportWidth: 1024
        },

        /**
         *
         * @private
         */
        _create: function () {
            var self = this,
                $el = $(this.element);

            this.$searchBtnMobile = $($el.find('button.search-button--mobile'));
            this.$searchParam = $('#searchParam');
            this.$searchForm = $("form[name='search']");
            this.currentAutoSuggestion;

            /**
             * Arrow Navigation through products in list
             */
            this.$searchParam.on('keydown', function (event) {
                let autoSuggestProductList = $('.makaira-autosuggestion .makaira-autosuggestion__list-item--product, .makaira-autosuggestion .makaira-autosuggestion__list-item--show-all');
                autoSuggestProductList.removeClass("active");
                if (event.originalEvent.keyCode == 40) {
                    event.preventDefault();
                    // arrowDown
                    if (self.currentAutoSuggestion == undefined || self.currentAutoSuggestion == autoSuggestProductList.length - 1) {
                        self.currentAutoSuggestion = 0;
                    } else {
                        self.currentAutoSuggestion++;
                    }
                } else if (event.originalEvent.keyCode == 38) {
                    event.preventDefault();
                    // arrowUp
                    if (self.currentAutoSuggestion == undefined || self.currentAutoSuggestion == 0) {
                        self.currentAutoSuggestion = autoSuggestProductList.length - 1;
                    } else {
                        self.currentAutoSuggestion--;
                    }
                } else if (event.originalEvent.keyCode == 13) {
                    // enter - if product is chosen -> go to product
                    //         if not, do nothing and let submit happen
                    if (self.currentAutoSuggestion != undefined) {
                        event.preventDefault();
                        autoSuggestProductList.eq(self.currentAutoSuggestion).find("a, button")[0].click();
                    }
                }
                autoSuggestProductList.eq(self.currentAutoSuggestion).addClass("active");
            });

            /**
             * event handling on input field
             */
            this.$searchParam.on('keyup', function (event) {
                if (!self._isDesktopViewPort()) {
                    var val = self.$searchParam.val();

                    if (val.length > 0) {
                        $(self.$searchBtnMobile.find('i')[0]).removeClass('sprite-search-close').addClass('sprite-search-trash');
                    } else {
                        $(self.$searchBtnMobile.find('i')[0]).removeClass('sprite-search-trash').addClass('sprite-search-close');
                    }
                }
            });

            /**
             * event handling on mobile search button
             */
            this.$searchBtnMobile.on('click', function (event) {
                event.stopPropagation();

                if (self._isDesktopViewPort()) {
                    $el.submit();
                } else if ($el.is(':visible')) {
                    var val = self.$searchParam.val();

                    if (val.length > 0) {
                        self.$searchParam.val('');
                        $(self.$searchBtnMobile.find('i')[0]).removeClass('sprite-search-trash').addClass('sprite-search-close');
                    } else if (val.length === 0) {
                        $(self.element).css({'display': 'none'});
                    }
                }
            });

            /**
             * add window resize for dev and testing and user edge case
             */
            $(window).resize(function () {
                if (self._isDesktopViewPort()) {
                    if (!$el.is(':visible')) {
                        $(self.element).css({'display': 'block'});
                    }
                }
            });

            /**
             * if current page is search and search parameter is given and it is a small browser, search will be displayed
             */
            if (!self._isDesktopViewPort() && $('body').hasClass('cl-search') && typeof self.$searchParam.val() === 'string' && self.$searchParam.val().length > 0) {
                $(self.element).css({'display': 'block'});
                $(self.$searchBtnMobile.find('i')[0]).removeClass('sprite-search-close').addClass('sprite-search-trash');
            }
        },

        /**
         *
         * @returns {number}
         * @private
         */
        _getWindowWidth: function () {
            return $(window).width();
        },

        /**
         *
         * @returns {boolean}
         * @private
         */
        _isDesktopViewPort: function () {
            var self = this;
            return (self._getWindowWidth() >= self.options.tabletLandscapeViewportWidth)
        }
    };

    $.widget("ui.aganSearch", aganSearch);
})(jQuery);
